import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import styles from "../../../layout/admin/Main.module.scss";
import { useNavigate } from "react-router-dom";
//共通コンポーネント
import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import RangeField from "../../../ui/RangeField";
import Select from "../../../ui/Select";
import Button from "../../../ui/Button";
import RadioGroup from "../../../ui/RadioGroup";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import TextAreaField from "../../../ui/TextAreaField";
import Annotation from "../../../ui/Annotation";
import Explanation from "../../../layout/admin/Explanation";
import UrlField from "../../../ui/UrlField";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
//専用コンポーネント
import Completion from "./Completion";
import CourseModal from "./CourseModal";
//API
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import {
  getCategoryList,
  postAddNotice,
  postUpdateNotice,
  getNoticeDetail,
} from "../../../../services/apiNotification";
import {
  validateMaxlength,
  validateRequired,
  validateNonNegInt,
  validateDateTime,
  validateUrl,
  validateFromToVal,
} from "../../../../utils/validate";

const NoticeDetailEdit = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  //定数；メール配信フラグ
  const is_email_true = 1;
  const is_email_false = 0;
  const is_mail_reflect_true = 1;
  const is_mail_reflect_false = 0;
  const default_mail_title_list = [
    "",
    "【渋谷ハチコウ大学】講座当選のお知らせ",
    "【渋谷ハチコウ大学】講座落選のお知らせ",
    "【渋谷ハチコウ大学】講座申込開始のお知らせ",
  ];
  //定数；画面モード
  const displayTypeNew = "new"; //画面モード_新規
  const displayTypeUpdate = "update"; //画面モード_更新
  //定数；区分ID
  const codeIsControl = "CD007";
  const codePublishedTo = "CD008";
  const codeLotteryStatus = "CD003";
  //定数；公開先選択
  const publishedStudents = 2;
  const publishedApplicant = 3;
  //定数；抽選ステータス
  const lotteryCancel = 4; //中止
  //URLパラメータ
  const { mode: displaytype } = useParams();
  const { noticeId } = useParams();
  //区分データ
  const [isControleElements, setIsControleElements] = useState([]); //公開フラグ
  const [publishedToElements, setPublishedToElements] = useState([]); //公開先
  const [lotteryStatusElements, setLotteryStatusElements] = useState([]); //抽選ステータス
  const [IsMailElements, setIsMailElements] = useState([]); //メール配信フラグ
  const [IsMailReflectElements, setIsMailReflectElements] = useState([]); // 内容・URL・備考のメール記載
  //カテゴリデータ
  const [categoryElements, setCategoryElements] = useState([]); //カテゴリ一覧
  //ラジオボタンSelected
  const [selectedIsControl, setSelectedIsControl] = useState(); //公開ステータス
  const [selectedPublished, setSelectedPublished] = useState(); //公開先
  const [selectedIsmail, setSelectedIsmail] = useState(); //メール送信フラグ
  const [selectedIsMailReflect, setSelectedIsMailReflect] = useState(); // 内容・URL・備考のメール記載
  // 講座選択モーダル
  const [showCourseModalFlag, setShowCourseModalFlag] = useState(false); //モーダル表示フラグ
  const [courseInfo, setCourseInfo] = useState(); //モーダルで取得した情報
  const [courseInfoDisplay, setCourseInfoDisplay] = useState({
    is_display: false,
  }); //表示する情報
  // 確認画面
  const [isConfirmation, setIsConfirmation] = useState(false);
  // 完了フラグ
  const [isCompFlg, setIsCompFlg] = useState(false);
  // 初期表示時のローディング表示
  const [loadingOnDisp, setLoadingOnDisp] = useState(false);
  // 登録時のローディング表示
  const [loading, setLoading] = useState(false);

  //初回レンダリング
  useEffect(() => {
    const setNoticeData = (d) => {
      setValue("updated_at", d.updated_at);
      setValue("notice_category_id", d.category_id);
      setValue("title", d.title);
      setValue("content", d.content);
      setValue("reference_url1", d.refarence_url1);
      setValue("reference_url2", d.refarence_url2);
      setValue("reference_url3", d.refarence_url3);
      setValue("remarks", d.remarks);
      setValue("period_from", d.period_from);
      setValue("period_to", d.period_to);
      setValue("generation_id", d.generation_id);
      setCourseInfoDisplay({
        is_display: d.course_name !== "",
        text: d.course_name,
      });
      setValue("course_id", d.course_id);
      setValue("lottery_status", d.lottery_status);
      //初回のみwatchで取得できない場合があるためsetvalue
      setValue("is_control", d.is_control);
      setSelectedIsControl(d.is_control);
      setValue("published_to", d.published_to);
      setSelectedPublished(d.published_to);
      setValue("is_email", d.is_email);
      setSelectedIsmail(d.is_email);
    };
    const mapCodeFuncRadio = (d) => {
      return {
        label: d.d_text,
        value: d.d_value,
        defaultChecked: d.is_init,
      };
    };
    const mapCodeFuncSelect = (d) => {
      return {
        text: d.d_text,
        value: d.d_value,
      };
    };
    const mapCategoryFunc = (d) => {
      return {
        text: d.category_name,
        value: d.category_id,
      };
    };

    (async function () {
      // ローディング表示開始
      setLoadingOnDisp(true);
      //カテゴリ一覧セット
      const ctData = await getCategoryList();
      setCategoryElements(ctData.map(mapCategoryFunc));
      //区分値チェックボックスセット
      //公開フラグ
      const icData = await getCodeMasterList({ code: codeIsControl });
      setIsControleElements(icData.map(mapCodeFuncRadio));
      //公開先
      const puData = await getCodeMasterList({ code: codePublishedTo });
      setPublishedToElements(puData.map(mapCodeFuncRadio));
      //抽選ステータス
      const ltData = await getCodeMasterList({ code: codeLotteryStatus });
      setLotteryStatusElements(ltData.map(mapCodeFuncSelect));
      //メール配信
      setIsMailElements([
        { label: "配信する", value: is_email_true },
        { label: "配信しない", value: is_email_false },
      ]);
      //メール初期値は新規/更新関係なく固定
      setValue("email_title", default_mail_title_list[0]);
      // 内容・URL・備考のメール記載
      setIsMailReflectElements([
        { label: "記載する", value: is_mail_reflect_true },
        { label: "記載しない", value: is_mail_reflect_false },
      ]);

      if (displaytype === displayTypeUpdate) {
        const nt_data = await getNoticeDetail(noticeId);
        if (Object.keys(nt_data).length === 0) {
          navigate("/admin/404");
          return;
        }
        //取得データで初期表示する
        setNoticeData(nt_data);
      } else {
        const findFunc = (d) => d.is_init === is_email_true;
        //is_initが設定されている区分を初期選択
        const icInit = icData.find(findFunc); //公開フラグ
        if (icInit !== undefined) {
          setValue("is_control", icInit.d_value);
          setSelectedIsControl(icInit.d_value);
        }
        const puInit = puData.find(findFunc);
        if (puInit !== undefined) {
          setValue("published_to", puInit.d_value);
          setSelectedPublished(puInit.d_value);
        }
        setValue("is_email", is_email_true); //メール配信（配信する）
        setSelectedIsmail(is_email_true);
      }
      // 内容・URL・備考のメール記載（記載しない）
      setValue("is_mail_reflect", is_mail_reflect_false);
      setSelectedIsMailReflect(is_mail_reflect_false);
      // ローディング表示終了
      setLoadingOnDisp(false);
    })();
  }, []); //初回レンダリング

  // 講座情報更新
  useEffect(() => {
    if (courseInfo) {
      setCourseInfoDisplay({
        is_display: true,
        text: courseInfo.name,
      });
      setValue("course_id", courseInfo.course_id);
    }
  }, [courseInfo]);

  // 講座情報更新
  useEffect(() => {
    if (courseInfoDisplay.text) {
      setValue("course_name", courseInfoDisplay.text);
    }
  }, [courseInfoDisplay]);

  // 学生情報削除
  const deleteCourseInfo = () => {
    setValue("course_id", "");
    setCourseInfoDisplay({
      is_display: false,
      text: "",
    });
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  //サブミットイベント
  async function onSubmit(data) {
    if (!isConfirmation) {
      setIsConfirmation(true);
      scrollTop();
    }
    if (isConfirmation) {
      if (displaytype === displayTypeNew) {
        // 新規お知らせ登録
        setLoading(true);
        await postAddNotice(data);
        setLoading(false);
        // 完了画面表示
        setIsCompFlg(true);
        scrollTop();
      } else if (displaytype === displayTypeUpdate) {
        // お知らせ更新
        setLoading(true);
        await postUpdateNotice(noticeId, data);
        setLoading(false);
        // 完了画面表示
        setIsCompFlg(true);
        scrollTop();
      }
    }
  }

  //戻るボタンイベント
  const handleBack = (e) => {
    if (isConfirmation) {
      setIsConfirmation(false);
      scrollTop();
      return;
    } else {
      //一覧画面に遷移
      navigate("/admin/notification");
      return;
    }
  };

  // 講座選択モーダルオープン
  const showCourseModal = () => {
    setShowCourseModalFlag(true);
  };

  return (
    <>
      {isCompFlg ? (
        <>
          <Completion
            subtitle="お知らせ登録完了"
            explanation="お知らせの登録が完了いたしました。"
            link={"/admin/notification"}
            btntext="一覧へ戻る"
          ></Completion>
        </>
      ) : (
        <div className={styles.main}>
          <ScreenTitle>お知らせ管理</ScreenTitle>
          <SubScreenTitle>
            {displaytype === displayTypeNew ? "お知らせ新規登録" : ""}
          </SubScreenTitle>
          {isConfirmation ? (
            <Explanation>
              入力内容をご確認の上、登録ボタンを押してください。
            </Explanation>
          ) : (
            <Explanation>
              必要事項をご入力の上、確認ボタンを押してください。
            </Explanation>
          )}
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <table className={styles.input_form_table}>
              <tr>
                <TextField
                  type="hidden"
                  name="updated_at"
                  errors={errors}
                  register={register}
                ></TextField>
              </tr>
              <tr>
                <Select
                  register={register}
                  label="カテゴリー"
                  name="notice_category_id"
                  errors={errors}
                  options={categoryElements}
                  watch={watch}
                  isSetdefalut={true}
                  defalut={{ text: "---選択していません---", value: "" }}
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(120),
                    ...validateRequired(),
                  }}
                  name="title"
                  errors={errors}
                  label="件名"
                  placeholder="件名"
                  required={true}
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextAreaField
                  register={register}
                  validation={{
                    ...validateMaxlength(1000),
                    ...validateRequired(),
                  }}
                  name="content"
                  errors={errors}
                  label="内容"
                  required={true}
                  isStatic={isConfirmation}
                />
              </tr>
              {[1, 2, 3].map((i) => {
                return (
                  <tr>
                    <UrlField
                      register={register}
                      validation={{
                        ...validateMaxlength(250),
                        ...validateUrl(),
                      }}
                      watch={watch}
                      type="url"
                      name={"reference_url" + i}
                      errors={errors}
                      label={"ご参考URL" + i}
                      placeholder="ご参考URL"
                      isStatic={isConfirmation}
                    ></UrlField>
                  </tr>
                );
              })}
              <tr>
                <TextAreaField
                  errors={errors}
                  register={register}
                  validation={{
                    ...validateMaxlength(250),
                  }}
                  label="備考"
                  name="remarks"
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <RangeField
                  type="datetime-local"
                  register={register}
                  validationFrom={{
                    ...validateDateTime(),
                  }}
                  validationTo={{
                    ...validateDateTime(),
                    ...validateFromToVal(
                      "period_from",
                      "period_to",
                      "終了日は開始日よりも後に設定してください",
                    ),
                  }}
                  nameFrom={"period_from"}
                  nameTo={"period_to"}
                  errors={errors}
                  label="掲載期間"
                  isStatic={isConfirmation}
                  watch={watch}
                ></RangeField>
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="公開"
                  name="is_control"
                  elements={isControleElements}
                  selectedValue={selectedIsControl}
                  setSelectedValue={setSelectedIsControl}
                  watch={watch}
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="公開先"
                  name="published_to"
                  elements={publishedToElements}
                  watch={watch}
                  selectedValue={selectedPublished}
                  setSelectedValue={setSelectedPublished}
                  isStatic={isConfirmation}
                />
              </tr>
              {selectedPublished === publishedStudents ? (
                <>
                  <tr>
                    {isConfirmation ? (
                      <></>
                    ) : (
                      <Annotation>例：2021年4月入学の場合「2104」</Annotation>
                    )}
                  </tr>
                  <tr>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(4),
                        ...validateRequired(),
                        ...validateNonNegInt(),
                      }}
                      name="generation_id"
                      errors={errors}
                      label="入学年月"
                      placeholder="件名"
                      required={true}
                      isStatic={isConfirmation}
                    ></TextField>
                  </tr>
                </>
              ) : (
                <></>
              )}
              {selectedPublished === publishedApplicant ? (
                <>
                  <tr>
                    <div className={styles.row_in_button}>
                      <TextField
                        errors={errors}
                        register={register}
                        validation={{
                          ...validateRequired(),
                        }}
                        label="講座ID"
                        name="course_id"
                        readOnly={true}
                        required={true}
                      />
                      {!isConfirmation ? (
                        <div className={styles.row_in_button__buttonbox}>
                          <Button
                            type="button"
                            styleType="search"
                            onClick={() => showCourseModal()}
                          >
                            講座選択
                          </Button>
                          <Button
                            type="button"
                            styleType="back"
                            onClick={() => deleteCourseInfo()}
                          >
                            削除
                          </Button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </tr>
                  {courseInfoDisplay.is_display ? (
                    <tr>
                      <TextField
                        label="講座名"
                        errors={errors}
                        register={register}
                        name="course_name"
                        readOnly={true}
                      />
                    </tr>
                  ) : (
                    <></>
                  )}
                  <tr>
                    <Select
                      register={register}
                      label="当選状況"
                      name="lottery_status"
                      errors={errors}
                      options={lotteryStatusElements}
                      watch={watch}
                      isSetdefalut={true}
                      defalut={{ text: "---選択していません---", value: "" }}
                      isStatic={isConfirmation}
                    />
                  </tr>
                </>
              ) : (
                <></>
              )}
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="お知らせメール"
                  name="is_email"
                  elements={IsMailElements}
                  watch={watch}
                  selectedValue={selectedIsmail}
                  setSelectedValue={setSelectedIsmail}
                  isStatic={isConfirmation}
                />
              </tr>
              {selectedIsmail === is_email_true ? (
                <>
                  <tr>
                    <td>
                      <TextField
                        register={register}
                        validation={{
                          ...validateMaxlength(60),
                          ...validateRequired(),
                        }}
                        name="email_title"
                        errors={errors}
                        label="メール件名"
                        placeholder="メール件名を入力または選択"
                        required={true}
                        isStatic={isConfirmation}
                        watch={watch}
                        list={!isConfirmation ? "email-title-list" : null}
                        datalistOptions={
                          !isConfirmation ? default_mail_title_list : []
                        }
                      ></TextField>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <RadioGroup
                        errors={errors}
                        register={register}
                        label="内容・URL・備考のメール記載"
                        name="is_mail_reflect"
                        elements={IsMailReflectElements}
                        watch={watch}
                        selectedValue={selectedIsMailReflect}
                        setSelectedValue={setSelectedIsMailReflect}
                        isStatic={isConfirmation}
                      />
                    </td>
                  </tr>
                </>
              ) : (
                <></>
              )}
              {/*講座IDに一致する講座がない場合警告 */}
              {(selectedPublished === publishedApplicant) &
              courseInfoDisplay.is_caution ? (
                <Explanation is_caution={true}>
                  {courseInfoDisplay.caution}
                </Explanation>
              ) : (
                <></>
              )}
            </table>
            <div className={styles.buttonbox}>
              <Button
                type="button"
                styleType="back"
                onClick={() => handleBack()}
              >
                {isConfirmation ? "変更ページへ戻る" : "一覧へ戻る"}
              </Button>
              <Button type="submit" styleType="new">
                {isConfirmation ? "登録" : "確認"}
              </Button>
            </div>
            {isConfirmation ? (
              <></>
            ) : (
              <div className={styles.buttonbox}>
                <Link className={styles.link} to="/admin/top">
                  トップページへ戻る
                </Link>
              </div>
            )}
          </Form>
          <CourseModal
            showFlag={showCourseModalFlag}
            setShowModal={setShowCourseModalFlag}
            setCourseInfo={setCourseInfo}
            //key={showStudentModalFlag}
          />
          {loadingOnDisp || loading ? (
            <>
              <Loading />
              <Progress setMsg={loading ? "登録中です" : "検索中です"} />
            </>
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  );
};
export default NoticeDetailEdit;
